import React, { useContext, useEffect, useState } from 'react';
import './InspectionForm.css';
import axios from 'axios';
import { ConfigContext } from '../../Context/ConfigContext';
import { useNavigate, useParams } from 'react-router-dom';
import { ContentLoader } from '../../Components/Shimmer';

const ViewSubmittedInspectionForm = () => {
    const { project_inspection_id } = useParams();
    const { apiHeaderJson, apiURL } = useContext(ConfigContext);
    const [questions, setQuestions] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [formHeader, setFormHeader] = useState({});
    const navigate = useNavigate();

    const renderPreviewQuestion = (question) => {
        const answers = question.answers?.map(a => a.value).filter(Boolean) || [];
        const lastAnswer = answers[answers.length - 1];

        switch (question.type) {
            case 'short-answer':
                return (
                    <input
                        type="text"
                        className="form-control google-input"
                        value={lastAnswer || ''}
                        placeholder="No answer submitted"
                        disabled
                    />
                );

            case 'paragraph':
                return (
                    <textarea
                        className="form-control google-input"
                        value={lastAnswer || ''}
                        rows={3}
                        placeholder="No answer submitted"
                        disabled
                    />
                );

            case 'multiple-choice':
                return lastAnswer ? (
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            checked
                            disabled
                            style={{ opacity: 1, pointerEvents: 'none' }}
                        />
                        <label
                            className="form-check-label"
                            style={{ color: 'black', fontWeight: 'bold' }}
                        >
                            {lastAnswer}
                        </label>
                    </div>
                ) : (
                    <p>No options submitted</p>
                );

            case 'checkbox':
                return lastAnswer ? (
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked
                            disabled
                            style={{ opacity: 1, pointerEvents: 'none' }}
                        />
                        <label
                            className="form-check-label"
                            style={{ color: 'black', fontWeight: 'bold' }}
                        >
                            {lastAnswer}
                        </label>
                    </div>
                ) : (
                    <p>No options submitted</p>
                );

            default:
                return <p>Unsupported question type</p>;
        }
    };


    const GetInfo = async () => {
        try {
            setLoadingList(true);

            const response = await axios.get(`${apiURL}api/inspections/GetSubmittedInspectionsQuestions`,

                {
                    params: { project_inspection_id },

                }
            );

            const { data, success } = response.data;
            if (success) {
                setFormHeader(data?.inspection || {});
                setQuestions(data?.questions || []);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingList(false);
        }
    };

    useEffect(() => {
        if (project_inspection_id) GetInfo();
    }, [project_inspection_id]);

    return (
        <div className="main-content">
            <div className="page-content">
                {loadingList ? (
                    <ContentLoader />
                ) : (
                    <div className="google-form-container">
                        <div className="form-preview">
                            <div className="preview-header">
                                <h1 className="preview-title">
                                    {formHeader?.inspection_title || 'Untitled form'}
                                </h1>
                                <p className="preview-description">
                                    {formHeader?.inspection_description || ''}
                                </p>
                            </div>
                            <div className="preview-questions">
                                {questions.length > 0 ? (
                                    questions.map((question) => (
                                        <div key={question.question_id} className="preview-question">
                                            <div className="preview-question-header">
                                                <label>
                                                    {question.question || "Question"}{" "}
                                                    {question.required && <span className="required-star">*</span>}
                                                </label>
                                            </div>
                                            {renderPreviewQuestion(question)}
                                        </div>
                                    ))
                                ) : (
                                    <p>No questions available</p>
                                )}
                            </div>
                            <div className="form-actions">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => window.print()}
                                >
                                    Print
                                    <i className="ri-printer-line ms-2" />
                                </button>

                                <button
                                    className="btn btn-info"
                                    onClick={() => navigate(-1)}
                                >
                                    Go Back
                                    <i className="ri-arrow-go-back-line ms-2" />
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ViewSubmittedInspectionForm;
